define.alias("shared/components/shared/configurable-address-fields", "settings/components/shared/configurable-address-fields");